/**
 * Single import surface for ALL product analytics.
 * - GA4 + first-party funnel events  -> lib/ga4.ts
 * - UTM capture / session attribution -> lib/ga4-tracking.ts
 * - Additional GA4 engagement events  -> lib/analytics.ts
 * New events: add the implementation in the right module above, re-export it
 * here, and import it from '@/lib/tracking' at the call site.
 *
 * NOTE: `trackToolEntryCtaClick` exists in both concrete modules. The facade
 * re-exports the version in lib/ga4.ts; the create hub uses the identically
 * shaped event in lib/analytics.ts alongside its other engagement events.
 */
export * from '@/lib/ga4'
export * from '@/lib/ga4-tracking'
// Explicit named re-exports from lib/analytics — excludes trackToolEntryCtaClick
// to avoid a collision with the GA4 version above (same name, different backend).
export {
  type SavedSoundSaveSource,
  trackSavedSoundSaveClick,
  trackSavedSoundUnsaveClick,
  trackSavedSoundsPageView,
  trackSavedSoundsClearAllClick,
  trackSavedSoundsPlayClick,
  trackSavedSoundsDownloadClick,
  trackSwapPackDownload,
  trackLibraryBrowseClick,
  trackLibraryZeroResultsRecoveryClick,
  trackLibraryZeroResultsViewed,
} from '@/lib/analytics'
